
import ITAssistantSDK from 'it-assistant-jssdk';

export default {
  name: 'RobotE',
  data() {
    return {
      assistant: null
    };
  },
  computed: {
    loginInfo() {
      return this.$store.state.global.loginInfo;
    }
  },
  methods: {
    initConfig() {
      // console.log('token', this.loginInfo.access_token);
      const assistant = new ITAssistantSDK();
      assistant.initConfig({
        host: process.env.VUE_APP_ROBOT_URL, // AI门户地址，根据环境配置 必填
        userCenterToken: this.loginInfo.access_token, // 用户中心token 必填
        hoverMessage: 'Hi～我是小e，随时为你解答IT问题~ 🥰', // 可选, 悬浮提示语
        width: '50%', // 弹窗宽度 可选
        height: '70%', // 弹窗高度 可选
        zIndex: '9999', // 弹窗层级 可选
        buttonWidth: '52px', // 按钮宽度 可选
        buttonHeight: '52px', // 按钮高度 可选
        buttonBottom: 'calc(32% + 110px)', // 按钮距离页面底部距离 可选
        buttonRight: '18px', // 按钮距离页面右侧距离 可选
        buttonRadius: '50%', // 按钮圆角 可选
        robotFloatingImageUrl: `${process.env.VUE_APP_ROBOT_URL}/itAssistant/it-assistant-hover.gif`, // 鼠标悬停按钮时显示的机器人悬浮图片 可选
        robotHiddenImageUrl: `${process.env.VUE_APP_ROBOT_URL}/itAssistant/it-assistant-normal.gif`, // 按钮默认显示的机器人图片 可选
        hoverWidth: '284px', // hover框的宽度
        hoverHeight: '46px', // hover框的高度
        hoverBoxShadow: '0px 4px 16px 0px rgba(0,0,0,0.24)', // hover框的阴影
        hoverFontSize: '14px', // hover框字体大小
        hoverPadding: '12px 7px 12px 16px', // hover框内边距
        hoverAfterTop: 'none', // hover框伪元素位置
        hoverAfterRight: '-16px', // hover框伪元素位置
        hoverAfterBottom: '2px', // hover框伪元素位置
        hoverAfterTransform: 'translateY(0%)', // hover框伪元素位置
        isPreload: true, // 是否预加载
        source: 'IT小e_igeely'
      });
      this.assistant = assistant;
    }
  },
  watch: {
    loginInfo: {
      handler(loginInfo) {
        !this.assistant && loginInfo && loginInfo.access_token && this.initConfig();
      },
      deep: true,
      immediate: true
    }
  }
};
